import { asApiFailure } from "@utils/apiFailure";

// The validate GET (the landing page's first read) fails in two ways the page
// must tell apart:
//   - "invalid"  the server answered and refused this link. Asking again gets
//                the same answer, so the page shows the invalid-link state and
//                the way to a new link — not a Retry that can only loop.
//   - "failed"   the check itself could not answer. That says nothing about
//                the link, so the page offers Retry.
// Separate from completeInvitationOutcome on purpose: that one classifies the
// complete-signup POST, where a 409 means "already registered" and the unmapped
// statuses keep the applicant on the form.
export type ValidateInvitationFailure = "invalid" | "failed";

// Client errors that are about the moment, not the link: a timed-out request
// and a rate limit both succeed when asked again.
const RETRYABLE_CLIENT_ERRORS = [408, 429];

export const validateInvitationOutcome = (
    error: unknown,
): ValidateInvitationFailure => {
    const status = asApiFailure(error)?.status;

    // No status: the request never got an answer (a dropped network).
    if (status === undefined) {
        return "failed";
    }

    const isClientError = status >= 400 && status < 500;

    return isClientError && !RETRYABLE_CLIENT_ERRORS.includes(status)
        ? "invalid"
        : "failed";
};
